
/**
 * Converts a string to Proper Case (e.g., "john DOE" → "John Doe")
 * @param str - the input string
 * @returns properly capitalized string
 */
export const capitalizeFirstLetter = (str: string | undefined): string => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
